import { Api } from '../api';
import { users } from '../endpoints';
import type { UserViewEntity } from './models';

export class UsersApi extends Api {
  static getUsers = (signal?: AbortSignal) => this.get<UserViewEntity[]>(users.getUsers(), { signal });
}
